//import Vue from 'vue';
import axios from 'axios';
import { API_URL } from '@/config/env';
import miniToastr from 'mini-toastr';
import { toastrOptions } from '@/thirdparty/options';

const client = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    responseType: 'json',
    headers: {'Content-Type': 'multipart/form-data' },
});

export default {
    async execute(method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(response => {
            //console.log("base.service.js GLOBAL LOG ajax query method:" + method + " url:" + resource);
            //console.log(response.data);
            return response.data;
        }).catch( (error) => {
            // handle unexpected error
            //console.log(error);
            //console.log(this);

            miniToastr.init(toastrOptions);
            miniToastr.error("Erreur de connexion, contacter votre administrateur ou patienter quelques instant et ré-essayez:"+ error);
            
        });
    },
    // AUTH methods
    checkLoggin(data) {
        return this.execute('post', '/UserSession/login', data);
    },
    getUser() {
        return this.execute('get', '/UserSession/currentUser');
    },
    // default service methods
    get(resource, option) {
        return this.execute('get', `${resource}`, option);
    },
    post(resource, data) {
        return this.execute('post', `${resource}`, data);
    },
  
}



// WEBPACK FOOTER //
// ./src/services/base.service.js